const SCREEN_GUTTER = 16;
const ANCHOR_GAP = 4;

interface MenuMeasurements {
    anchor: { top: number; bottom: number; left: number; width: number };
    viewportWidth: number;
    viewportHeight: number;
    viewportTop?: number;
    viewportLeft?: number;
    verticalMargin: number;
}

/** Sticky header/footer clearance must never become a horizontal inset. */
export const getSelectorMenuLayout = ({
    anchor, viewportWidth, viewportHeight, verticalMargin, viewportTop = 0, viewportLeft = 0,
}: MenuMeasurements) => {
    const width = Math.min(anchor.width, Math.max(0, viewportWidth - SCREEN_GUTTER * 2));
    const left = Math.max(viewportLeft + SCREEN_GUTTER, Math.min(anchor.left, viewportLeft + viewportWidth - SCREEN_GUTTER - width));
    const margin = Math.min(Math.max(SCREEN_GUTTER, verticalMargin), viewportHeight / 2);
    const topBound = viewportTop + margin;
    const bottomBound = viewportTop + viewportHeight - margin;
    const lowerAnchor = Math.max(topBound, Math.min(bottomBound, anchor.bottom + ANCHOR_GAP));
    const upperAnchor = Math.max(topBound, Math.min(bottomBound, anchor.top - ANCHOR_GAP));
    const below = bottomBound - lowerAnchor;
    const above = upperAnchor - topBound;
    const opensAbove = below < 240 && above > below;

    return {
        width,
        maxHeight: Math.max(0, opensAbove ? above : below),
        anchorPosition: {
            top: opensAbove ? upperAnchor : lowerAnchor,
            left,
        },
        transformOrigin: { vertical: opensAbove ? 'bottom' as const : 'top' as const, horizontal: 'left' as const },
    };
};
